import React, { FC } from "react";

import { IconName } from "../icons/icons.type";
import Icon from "../icons/icon";

import styles from "./button.module.css";

type FlatButtonProps = {
  icon: IconName;
  title: string;
  onClick?: () => void;
};

const FlatButton: FC<FlatButtonProps> = (props) => {
  const { icon, title, onClick } = props;

  function handleOnClick() {
    onClick?.();
  }

  return (
    <button onClick={handleOnClick} className={styles.flatButton}>
      <div className={styles.iconContainer}>
        <Icon name={icon} size={32} />
      </div>
      <div className={styles.title}>{title}</div>
    </button>
  );
};

export default FlatButton;
